<template>
  <a-config-provider
    :wave="{ disabled: true }"
    :theme="{
      token: {
        colorPrimary: '#4D65FF',
        controlHeight: 40,
        controlHeightLG: 50,
        borderRadius: 10,
        
      },
    }"
  >
    <RouterView v-if="isRouterAlive" />
  </a-config-provider>
</template>

<!-- <script setup lang="ts">
import { ref, nextTick, provide } from "vue";

const isRouterAlive = ref(true);
function reload() {
  isRouterAlive.value = false;
  nextTick(() => {
    isRouterAlive.value = true;
  });
}
provide("reload", reload);
</script> -->

<script lang="ts">
// 在 App.vue 中使用 setup 时，需要将 setup 与 script 分开写,
// 否则会生成 _plugin-vue_export-helper.js 文件，导致报错
// chrome 插件的文件不能使用 _ 开头的文件名
import { ref, nextTick, provide } from "vue";
import { provideReloadKey } from "@/config";
export default {
  setup() {
    const isRouterAlive = ref(true);
    function reload() {
      isRouterAlive.value = false;
      nextTick(() => {
        isRouterAlive.value = true;
      });
    }
    provide(provideReloadKey, reload);
    return {
      isRouterAlive,
    };
  },
};
</script>
